export default function componentStyleOverrides(theme) {
    const bgColor = theme.textWhite;
    return {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                        padding: '6px 6px 9px 6px !important',
                    }
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    background: theme.menuSelectedBack,
                    color: '#fff',
                    fontWeight: 500,
                    borderRadius: '4px',
                    fontSize: `${theme?.customization?.buttonFontSize}px`,
                    '&:hover': {
                        // backgroundImage: 'linear-gradient(to left, #007ebd, #006dcb, #0058d3, #003ed4, #2104cb)',
                        background: theme.menuSelectedBack,
                        color: '#fff'
                    }
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f5f5f5'
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: `${theme?.customization?.typoFontSize}px`,
                    color: '#676767'
                }
            }
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: {
                    backgroundImage: 'none'
                },
                rounded: {
                    borderRadius: `${theme?.customization?.borderRadius}px`
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    color: theme.colors?.textDark,
                    padding: '24px'
                },
                title: {
                    fontSize: '1.02rem'
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '24px'
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: '24px'
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    color: 'white',
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    '&.Mui-selected': {
                        color: '#676767', // theme.menuSelected
                        backgroundColor: theme.menuSelectedBack,
                        width: '600px',
                        '&:hover': {
                            color: '#676767',
                            backgroundColor: theme.menuSelectedBack,
                            width: '600px',
                        },
                        '& .MuiListItemIcon-root': {
                            // color: theme.menuSelected
                            color: '#676767',
                        },
                        '& .MuiListItemText-root': {
                            // color: theme.menuSelected
                            color: '#676767',
                        }
                    },
                    '&:hover': {
                        backgroundColor: theme.menuSelectedBack,
                        width: '600px',
                        color: '#676767',
                        '& .MuiListItemIcon-root': {
                            // color: theme.menuSelected
                            color: '#676767',
                        },
                        '& .MuiListItemText-root': {
                            // color: theme.menuSelected
                            color: '#676767',
                        }
                    }
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: theme.textWhite,
                    minWidth: '36px'
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    color: theme.textDark
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: theme.textDark,
                    '&::placeholder': {
                        color: theme.darkTextSecondary,
                        fontSize: '0.875rem'
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontSize: `${theme?.customization?.textfieldFontSize}px`,
                    background: bgColor,
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.colors?.grey400
                    },
                    '&:hover $notchedOutline': {
                        borderColor: theme.colors?.primaryLight
                    },
                    '&.MuiInputBase-multiline': {
                        padding: 1
                    },
                },
                input: {
                    fontWeight: 500,
                    background: bgColor,
                    padding: '15.5px 14px',
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    '&.MuiInputBase-inputSizeSmall': {
                        padding: '10px 14px',
                        '&.MuiInputBase-inputAdornedStart': {
                            paddingLeft: 0
                        }
                    }
                },
                inputAdornedStart: {
                    paddingLeft: 4
                },
                notchedOutline: {
                    borderRadius: `${theme?.customization?.borderRadius}px`
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&.MuiTableRow-hover': {
                        '&:hover': {
                            backgroundColor: '#ebfdff'
                        },
                    }
                }
            }
        },
        MuiTablePagination: {
            styleOverrides: {
                selectLabel: {
                    fontSize: `${theme?.customization?.typoFontSize}px`
                },
                displayedRows: {
                    fontSize: `${theme?.customization?.typoFontSize}px`
                },
                select: {
                    fontSize: `${theme?.customization?.typoFontSize}px`
                }
            }
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: theme.colors?.grey300
                    }
                },
                mark: {
                    backgroundColor: theme.paper,
                    width: '4px'
                },
                valueLabel: {
                    color: theme?.colors?.primaryLight
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: theme.divider,
                    opacity: 1
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    color: theme.colors?.primaryDark,
                    background: theme.colors?.primary200
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    '&.MuiChip-deletable .MuiChip-deleteIcon': {
                        color: 'inherit'
                    }
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: theme.paper,
                    background: theme.colors?.grey700
                }
            }
        }
    };
}
